/**
 * A building's round progress today (FR-2, ruling Isaiah Cotto 2026-10-27): "Seen n of N, last seen hh:mm", drawn on
 * the provider's My day and the scheduling managers' provider calendar. Counts only: no resident is ever named here.
 * The server sends it for TODAY's visits only (the America/New_York visit day); every other day carries none.
 */
export interface RoundProgress {
  visit_date: string;
  seen: number;
  total: number;
  last_seen_at: string | null;
}

/** 'h:mm AM' in America/New_York, whatever zone the browser is in. */
export function easternTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit' });
}

/** "Seen 4 of 12 · last seen 10:42 AM"; null when there is no progress to state. */
export function roundProgressWords(round: RoundProgress | null | undefined): string | null {
  if (!round || typeof round.total !== 'number' || round.total <= 0) return null;
  const last = easternTime(round.last_seen_at);
  return `Seen ${round.seen} of ${round.total}${last ? ` · last seen ${last}` : ''}`;
}
